module.exports = __webpack_public_path__ + "media/styles/images/svg/pen-teal-c24f8ee66978a40bb9e7c23db8f08250.svg";